/* WAVY-CRO-1001B | wavy-urgency.js
   Shared sale countdown for the product page (snippets/wavy-urgency.liquid) and the cart drawer.
   Contract (COMMON2): any element with [data-wj-urgency][data-deadline] starting `hidden`; optional [data-wj-urg-label]
   and [data-wj-urg-time] inside. While now < deadline the element is shown, the time is written every second as
   "2d 04h 12m 09s" (no day part when 0) and the label is "Sale ends Sunday", or "Sale ends tonight" inside the last
   24 hours. At/after the deadline the element is hidden again (never a "0d 00h" state, never a new deadline).
   A wrapper [data-wj-urg-slot] (the PDP reserves the strip's height so the title never jumps) is hidden together with it.
   Re-scans on cart:updated / wj:cart-rendered and on a cheap 1 s tick (the cart drawer re-renders its HTML). The tick
   pauses while the tab is hidden. One fixed deadline: Sunday 4 Oct 2026, 11:59:59 pm NZDT. */
(function () {
  'use strict';
  if (window.wjUrgency) return;

  var DEADLINE_ISO = '2026-10-04T23:59:59+13:00';
  var DEADLINE = Date.parse(DEADLINE_ISO);
  var DAY = 864e5;
  var timer = 0;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function fmt(ms) {
    var s = Math.floor(ms / 1000);
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600); s -= h * 3600;
    var m = Math.floor(s / 60); s -= m * 60;
    return (d > 0 ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
  }

  function setText(node, text) { if (node && node.textContent !== text) node.textContent = text; }

  function hide(el) {
    if (!el.hidden) el.hidden = true;
    var slot = el.closest && el.closest('[data-wj-urg-slot]');
    if (slot && !slot.hidden) slot.hidden = true;
  }

  function refresh() {
    var els = document.querySelectorAll('[data-wj-urgency]');
    var live = 0;
    var now = Date.now();
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var end = Date.parse(el.getAttribute('data-deadline') || '');
      if (isNaN(end)) end = DEADLINE;
      var left = end - now;
      if (left <= 0) { hide(el); continue; }
      live++;
      setText(el.querySelector('[data-wj-urg-label]'), left < DAY ? 'Sale ends tonight' : 'Sale ends Sunday');
      setText(el.querySelector('[data-wj-urg-time]'), fmt(left));
      if (el.hidden) el.hidden = false;
    }
    return live;
  }

  function stop() { if (timer) { clearTimeout(timer); timer = 0; } }

  function tick() {
    timer = 0;
    var live = refresh(); /* always paint once, even in a background tab, so the strip is right when the tab is shown */
    if (document.hidden) return; /* then pause the tick; visibilitychange restarts it */
    if (!live && Date.now() >= DEADLINE) return; /* past the shared deadline and nothing left to count: stop ticking */
    timer = setTimeout(tick, 1000 - (Date.now() % 1000) + 15); /* land just after each second boundary */
  }

  function start() { stop(); tick(); }

  function boot() { start(); }

  window.wjUrgency = { deadline: DEADLINE, deadlineISO: DEADLINE_ISO, refresh: refresh, version: 'WAVY-CRO-1001B' };

  document.addEventListener('cart:updated', refresh);
  document.addEventListener('wj:cart-rendered', refresh);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
